import * as React from 'react';
import { withPermissionsProps } from '.';
import { StatefulTooltip, TooltipProps, Tooltip } from '../../Components/Tooltip';

interface IInjectedProps {}

export const addTooltip = (tooltipProps: TooltipProps = {}) => <TOriginalProps extends {}>(
	Component:
		| React.ComponentClass<TOriginalProps & IInjectedProps>
		| React.StatelessComponent<TOriginalProps & IInjectedProps>,
) => {
	type ResultProps = TOriginalProps; // & ExternalProps;
	const result = class YourComponentName extends React.Component<ResultProps> {
		constructor(props: ResultProps) {
			super(props);
		}

		render(): JSX.Element {
			return tooltipProps.content ? (
				<StatefulTooltip {...tooltipProps}>
					<Component {...this.props} {...this.state} />
				</StatefulTooltip>
			) : (
				<Component {...this.props} {...this.state} />
			);
		}
	};

	return result;
};

// eslint-disable-next-line @typescript-eslint/class-name-casing, @typescript-eslint/interface-name-prefix
export interface withTooltipProps {
	tooltip?: TooltipProps;
	RootRef?: any;
	anchor?: any;
	ref?: any;
}

export const withTooltip = (WrapperComponent: any) => {
	return class WithAuth<P> extends React.Component<P & withTooltipProps & withPermissionsProps> {
		render() {
			const { tooltip, anchor = {}, ...rest } = this.props;

			const pos = tooltip?.placement ? tooltip.placement : 'auto';
			const ignoreBoundary = tooltip?.ignoreBoundary ? tooltip.ignoreBoundary : false;
			const { Anchor, anchorProps } = anchor;

			if (tooltip?.content) {
				return (
					<Tooltip
						showArrow
						placement={pos}
						content={tooltip?.content}
						accessibilityType={'tooltip'}
						returnFocus
						ignoreBoundary={ignoreBoundary}
						onMouseEnterDelay={tooltip?.onMouseEnterDelay}
						onMouseLeaveDelay={tooltip?.onMouseLeaveDelay}
						overrides={{
							Body: {
								style: {
									zIndex: 9,
									...tooltip?.BodyStyle,
								},
							},
						}}
					>
						{Anchor ? (
							<Anchor {...anchorProps}>
								<WrapperComponent {...rest} ref={rest.RootRef} />
							</Anchor>
						) : (
							<WrapperComponent {...rest} ref={rest.RootRef} />
						)}
					</Tooltip>
				);
			}

			return <WrapperComponent {...rest} />;
		}
	};
};
